var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 789,
    viewBox: "0 0 1728 789",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_75_3609)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.04
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1767.57 756.955C1753.48 764.562 1738.94 772.403 1724.33 779.541C1717.74 782.77 1710.84 785.928 1703.97 789H1710.89C1715.87 786.744 1720.8 784.445 1725.6 782.096C1740.23 774.936 1754.83 767.074 1768.92 759.467C1770.62 758.552 1772.31 757.643 1774.01 756.721V753.492C1771.86 754.635 1769.71 755.791 1767.58 756.948L1767.57 756.955Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.08
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1772.66 713.769C1755.92 724.817 1732.98 739.939 1697.64 761.631C1684.83 769.487 1668.15 777.853 1650.5 786.716C1648.99 787.475 1647.47 788.241 1645.93 789.008H1652.28C1669.8 780.223 1686.32 771.906 1699.12 764.065C1734.35 742.444 1757.25 727.351 1773.99 716.302V712.903C1773.55 713.187 1773.11 713.485 1772.65 713.776L1772.66 713.769Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1723.58 708.042C1712.36 717.409 1699.66 728.046 1683.59 739.499C1660.92 755.671 1638.35 766.407 1609.78 779.995C1603.68 782.876 1597.43 785.864 1590.91 789.007H1597.48C1602.09 786.793 1606.59 784.658 1611 782.571C1639.7 768.926 1662.36 758.147 1685.24 741.826C1701.4 730.303 1714.15 719.637 1725.4 710.228C1741.23 696.994 1755.14 685.371 1774.01 674.897V671.626C1754.26 682.405 1739.94 694.361 1723.59 708.05L1723.58 708.042Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1747.59 641.312C1745.23 643.384 1742.81 645.548 1740.39 647.62C1720.69 664.438 1707.27 677.587 1695.42 689.16C1661.27 722.582 1644.13 739.357 1540.67 780.109C1532.92 783.167 1525.64 786.112 1518.78 789H1526.19C1531.16 786.957 1536.32 784.885 1541.72 782.756C1645.71 741.784 1662.98 724.881 1697.4 691.204C1709.22 679.644 1722.6 666.545 1742.23 649.792C1744.69 647.684 1747.13 645.527 1749.47 643.441C1756.92 636.842 1764.53 630.093 1773.99 624.126V620.776C1763.65 627.07 1755.51 634.266 1747.58 641.312H1747.59Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-25.6699 753.229C-32.9029 749.575 -40.0507 745.984 -47 742.202V745.445C-40.4549 748.979 -33.7396 752.356 -26.9463 755.77C-8.06265 765.299 11.3954 775.106 29.2154 789.007H33.7891C14.9906 773.722 -5.65167 763.313 -25.6628 753.229H-25.6699Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1768.15 587.631C1753.9 593.875 1752.42 595.429 1714.57 635.387C1703.98 646.563 1690.8 660.471 1673.67 678.374C1630.33 723.632 1582.29 741.414 1531.43 760.226C1508.38 768.762 1484.84 777.462 1460.79 789H1467.46C1489.53 778.761 1511.18 770.756 1532.41 762.894C1583.59 743.962 1631.94 726.073 1675.73 680.34C1692.87 662.429 1706.04 648.528 1716.64 637.345C1754.11 597.792 1755.56 596.245 1769.28 590.228C1770.79 589.568 1772.37 588.922 1774 588.305V585.261C1771.98 586.02 1770.01 586.793 1768.15 587.624V587.631Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8837 774.418C47.1488 754.848 22.0037 743.906 -2.31885 733.319C-17.5435 726.698 -32.9879 719.978 -47 711.059V714.45C-33.2503 722.973 -18.2526 729.494 -3.45343 735.937C21.6988 746.879 45.4469 757.218 62.7776 776.327C67.0536 781.06 70.9821 785.247 74.6765 789.008H78.683C74.4567 784.771 69.9113 779.967 64.8908 774.426L64.8837 774.418Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1717.45 578.357C1634.06 694.099 1601.44 708.958 1519.39 734.872C1460.47 753.485 1428.88 770.217 1400.35 789H1405.57C1433.02 771.296 1464.2 755.287 1520.25 737.583C1560 725.023 1590.47 714.379 1620.75 691.679C1649.42 670.185 1678.11 637.842 1719.76 580.024C1736.5 556.792 1755.37 548.312 1774 541.819V538.804C1754.63 545.488 1734.98 554.025 1717.45 578.357Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4543 757.6C69.0526 737.107 43.1132 727.045 15.6493 716.394C-6.45369 707.815 -28.968 699.066 -47.0078 684.455V688.081C-45.7952 689.018 -44.5543 689.947 -43.2779 690.87C-25.9401 703.302 -5.3262 711.306 14.6211 719.048C41.7163 729.557 67.3152 739.484 83.2277 759.396C94.0842 772.949 102.728 782.252 110.323 789H114.705C106.614 782.216 97.3887 772.537 85.4472 757.6H85.4543Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1765.2 496.462C1759.95 500.812 1751.22 504.055 1741.97 507.482C1723.14 514.458 1699.71 523.143 1691.85 546.347C1690.14 551.35 1688.9 555.763 1687.69 560.042C1682.64 577.896 1678.64 592.002 1647.72 627.617C1594.89 688.465 1568.04 696.391 1503.2 715.522C1500.39 716.352 1497.51 717.196 1494.55 718.069C1416.95 741.053 1383.41 766.279 1355.71 789H1360.22C1387.21 767.031 1420.82 742.891 1495.36 720.801C1498.32 719.928 1501.19 719.07 1504 718.254C1569.42 698.953 1596.51 690.955 1649.87 629.483C1681.22 593.386 1685.27 579.01 1690.42 560.816C1691.62 556.572 1692.86 552.187 1694.54 547.262C1701.97 525.336 1723.74 517.268 1742.96 510.15C1752.43 506.638 1761.4 503.324 1767.01 498.655C1769.72 496.42 1772.04 493.78 1774 490.771V484.86C1771.84 489.508 1768.91 493.397 1765.2 496.462Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M110.352 745.722C103.786 735.284 97.5809 725.428 81.1011 716.955C70.0815 711.285 56.1616 706.95 41.4334 702.373C9.19005 692.325 -26.0599 681.34 -47 653.396V657.817C-41.5398 664.495 -35.016 670.498 -27.4001 675.876C-7.05571 690.253 18.2596 698.137 40.5895 705.083C55.1972 709.632 69.0037 713.939 79.8034 719.481C95.5812 727.592 101.318 736.696 107.941 747.234C115.961 759.978 124.832 774.063 153.388 789H159.713C127.803 773.446 118.613 758.85 110.352 745.715V745.722Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.182 779.124C169.754 767.415 150.296 752.052 138.121 727.77L137.461 726.45C134.398 720.312 131.228 713.954 125.775 708.057C111.501 692.581 86.5116 686.117 60.0547 679.262C13.3596 667.178 -39.5685 653.49 -42.9013 584.779C-43.3481 575.555 -44.8798 567.451 -47 560.128V572.993C-46.376 576.754 -45.9434 580.713 -45.7449 584.921C-42.3057 655.718 11.7003 669.69 59.3455 682.029C85.3841 688.771 109.983 695.129 123.683 709.995C128.867 715.6 131.944 721.767 134.923 727.735L135.575 729.054C141.922 741.707 150.318 752.017 161.224 760.575C171.875 768.934 185.298 775.881 202.246 781.82C209.578 784.389 217.527 786.78 226.207 789.015H238.212C225.086 785.992 213.507 782.764 203.182 779.131V779.124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.22 747.766C1331.12 737.264 1341.41 727.337 1352.84 719.574C1362.74 712.854 1367.96 711.094 1372.58 709.54C1375.33 708.625 1377.93 707.745 1381.03 705.935C1382.17 705.275 1383.03 704.722 1383.78 704.239C1386.03 702.799 1387.65 701.742 1394.53 699.024C1430.71 684.612 1457.15 678.467 1480.48 673.06C1520.41 663.778 1549.27 657.087 1595.22 614.234C1617 593.919 1629.63 576.115 1633.83 559.801C1637.55 545.432 1634.24 534.263 1631.35 524.406C1626.55 508.15 1622.77 495.32 1650.82 474.6C1685.05 449.303 1699.46 435.671 1705.88 422.501C1712.72 408.501 1710.19 395.281 1706.03 373.383C1705.02 368.082 1703.88 362.086 1702.76 355.494C1700.12 339.777 1686.56 310.925 1667.4 280.185C1647.64 248.494 1626.94 222.722 1612.02 211.248C1599.36 201.512 1585.73 196.091 1565.1 187.895C1547.1 180.749 1524.73 171.851 1493.16 156.353C1484.19 151.947 1477.24 148.42 1471.12 145.305C1449.61 134.372 1409.64 122.122 1351.21 108.555C1331.99 104.091 1308.07 98.5424 1278.73 91.6309C1215.46 76.7365 1166.55 81.1289 1112.59 92.305C1052.63 104.73 1018.28 107.618 985.056 110.4C951.054 113.252 918.952 115.949 862.301 128.274C810.898 139.451 791.957 141.814 775.251 143.893C753.892 146.554 737.015 148.661 663.324 167.487C611.914 180.621 558.752 179.401 507.334 178.216C456.937 177.059 409.335 175.966 371.957 189.676C353.917 196.296 344.522 201.044 335.438 205.635C319.242 213.816 303.939 221.551 242.367 239.057C171.484 259.202 154.047 271.577 127.654 290.311C114.174 299.883 97.389 311.783 69.4854 327.401C15.7276 357.474 7.36716 369.927 -7.81493 392.549C-15.2961 403.697 -24.6138 417.591 -42.3061 437.367C-43.9584 439.205 -45.5184 441.008 -47.0146 442.767V447.21C-44.8944 444.627 -42.6182 441.98 -40.193 439.262C-22.3588 419.344 -12.9844 405.365 -5.45358 394.146C9.48032 371.893 17.706 359.631 70.8753 329.899C98.9135 314.203 115.769 302.246 129.306 292.631C156.387 273.415 172.739 261.828 243.147 241.803C304.982 224.226 320.398 216.435 336.721 208.182C345.727 203.626 355.045 198.922 372.936 192.358C399.591 182.58 431.728 180.437 466.432 180.437C479.721 180.437 493.386 180.749 507.27 181.068C558.879 182.253 612.24 183.474 664.026 170.247C737.547 151.471 754.346 149.371 775.605 146.724C792.376 144.638 811.38 142.268 862.911 131.063C919.385 118.773 951.401 116.084 985.297 113.238C1018.61 110.449 1053.05 107.554 1113.16 95.0937C1166.77 83.9886 1215.32 79.6174 1278.08 94.3983C1307.43 101.303 1331.34 106.866 1350.57 111.322C1408.79 124.833 1448.54 137.002 1469.83 147.831C1475.97 150.953 1482.92 154.487 1491.91 158.901C1523.58 174.448 1546.02 183.368 1564.05 190.534C1584.46 198.645 1597.94 204.003 1610.29 213.497C1624.94 224.78 1645.4 250.268 1664.98 281.675C1683.97 312.124 1697.37 340.586 1699.95 355.955C1701.07 362.576 1702.22 368.593 1703.22 373.901C1707.28 395.225 1709.73 408.097 1703.32 421.245C1697.12 433.94 1682.94 447.302 1649.12 472.294C1619.49 494.192 1623.72 508.568 1628.62 525.201C1631.55 535.171 1634.59 545.489 1631.08 559.084C1627.02 574.852 1614.66 592.201 1593.29 612.134C1547.88 654.468 1519.34 661.096 1479.83 670.271C1456.41 675.707 1429.85 681.873 1393.48 696.356C1386.35 699.194 1384.53 700.365 1382.25 701.834C1381.48 702.331 1380.68 702.842 1379.61 703.473C1376.75 705.134 1374.39 705.928 1371.67 706.844C1367.12 708.369 1361.45 710.271 1351.23 717.225C1339.6 725.109 1329.23 735.121 1318.25 745.708C1303.52 759.936 1288.26 774.646 1268.05 786.226C1266.44 787.142 1264.78 788.071 1263.11 789.001H1268.93C1269.1 788.894 1269.3 788.795 1269.47 788.696C1289.99 776.93 1305.37 762.1 1320.23 747.759L1320.22 747.766Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.787 788.808C457.391 788.808 453.881 788.815 450.25 788.83C414.433 788.95 369.865 789.113 303.613 778.221C247.6 769.018 209.982 758.225 188.595 745.232C169.945 733.9 165.549 722.191 161.308 710.88C159.06 704.899 156.741 698.704 152.373 692.786C137.39 672.435 99.9699 664.444 75.2148 659.137C70.1233 658.044 65.7268 657.107 62.0962 656.185C-17.2038 636.061 -21.033 601.439 -24.4155 570.884C-25.153 564.242 -25.8479 557.962 -27.2661 551.973C-29.4006 542.976 -33.8538 534.148 -38.5552 524.796C-41.5476 518.864 -44.5543 512.882 -47.0078 506.779V513.953C-45.1358 518.048 -43.1077 522.085 -41.1009 526.08C-36.4704 535.27 -32.0952 543.969 -30.0388 552.633C-28.656 558.445 -27.9682 564.647 -27.2449 571.204C-25.5714 586.339 -23.6709 603.476 -12.006 619.045C1.26854 636.728 25.272 649.784 61.3871 658.945C65.0674 659.882 69.4851 660.826 74.612 661.918C98.9487 667.127 135.73 674.996 150.076 694.489C154.203 700.08 156.351 705.821 158.628 711.881C163.045 723.667 167.612 735.83 187.106 747.68C208.804 760.857 246.763 771.771 303.138 781.038C326.893 784.941 347.861 787.425 366.653 789.007H478.615C472.97 788.844 467.049 788.815 460.773 788.815L460.787 788.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.97 759.708C1277.38 748.277 1288.58 737.086 1299.45 726.258C1317.12 708.61 1333.82 691.942 1375.24 675.671C1400.25 665.864 1425.53 659.747 1449.98 653.851C1502.09 641.255 1551.3 629.355 1591.79 584.168C1619.33 553.429 1612.25 532.496 1606 514.025C1600.39 497.491 1595.56 483.207 1615.63 464.339C1622.64 457.725 1630.87 452.077 1638.84 446.599C1657.69 433.635 1677.19 420.23 1682.23 393.28C1684.93 378.882 1683.35 361.887 1677.41 341.337C1670.8 318.46 1658.97 291.701 1641.25 259.571C1611.69 205.954 1592.32 198.02 1540.58 176.839C1521.95 169.211 1498.76 159.716 1469.36 145.695C1463.77 143.034 1459.08 140.742 1454.96 138.719C1434.63 128.761 1388.71 116.05 1317.21 100.586C1307.3 98.4427 1296.48 96.101 1284.62 93.5252C1280.98 92.7375 1277.44 91.957 1274 91.1835C1251.19 86.117 1231.49 81.7388 1204.5 81.5188C1173.69 81.2846 1145.95 86.195 1113.85 91.9002C1091.84 95.8101 1066.87 100.245 1037.85 103.417C1015.51 105.851 999.656 107.362 986.913 108.583C953.315 111.785 886.675 124.622 786.993 147.093C765.585 151.918 741.114 157.438 712.983 163.754C653.368 177.151 597.965 178.868 544.392 180.522C486.826 182.303 432.451 183.984 381.119 200.546C326.56 218.159 288.828 228.263 261.279 235.643C207.968 249.913 188.02 255.256 146.459 287.068C129.15 300.309 110.897 309.491 93.2404 318.382C60.9261 334.639 30.406 350.002 7.38818 387.795C-5.99277 409.764 -18.4022 422.153 -28.3723 432.116C-33.5418 437.282 -38.0092 441.731 -41.888 446.691C-43.8026 449.153 -45.5116 451.616 -47.0078 454.092V459.939C-45.1216 456.2 -42.7035 452.375 -39.6401 448.458C-35.8748 443.633 -31.4641 439.233 -26.3585 434.138C-16.282 424.069 -3.7307 411.552 9.82043 389.292C32.4198 352.187 62.5855 337.009 94.5168 320.937C112.287 311.996 130.667 302.75 148.19 289.352C189.304 257.889 209.109 252.581 262.023 238.403C289.601 231.024 327.368 220.905 381.991 203.271C432.948 186.823 487.124 185.148 544.484 183.381C598.192 181.721 653.73 180.004 713.607 166.55C741.738 160.227 766.216 154.714 787.624 149.881C887.184 127.439 953.706 114.624 987.19 111.435C999.947 110.222 1015.82 108.711 1038.17 106.269C1067.29 103.083 1092.3 98.6413 1114.35 94.7244C1146.33 89.0405 1173.94 84.1301 1204.49 84.3856C1231.17 84.5984 1250.73 88.9483 1273.39 93.9864C1276.84 94.7528 1280.38 95.5333 1284.03 96.3281C1295.87 98.8968 1306.7 101.238 1316.62 103.381C1387.9 118.799 1433.6 131.437 1453.71 141.295C1457.84 143.318 1462.54 145.617 1468.13 148.285C1497.62 162.342 1520.85 171.85 1539.5 179.493C1590.58 200.397 1609.69 208.224 1638.76 260.961C1656.39 292.915 1668.13 319.475 1674.68 342.161C1680.49 362.271 1682.04 378.832 1679.43 392.79C1674.62 418.57 1656.45 431.059 1637.23 444.271C1629.17 449.813 1620.86 455.526 1613.68 462.288C1592.28 482.412 1597.63 498.222 1603.29 514.968C1609.59 533.56 1616.1 552.783 1589.67 582.295C1549.78 626.822 1500.98 638.623 1449.31 651.105C1424.78 657.037 1399.4 663.168 1374.2 673.052C1332.22 689.536 1315.31 706.41 1297.42 724.264C1286.68 734.993 1275.56 746.091 1258.41 757.352C1245.79 765.648 1232.54 773.169 1218.48 781.138C1214.01 783.678 1209.41 786.29 1204.65 789.036H1210.38C1213.62 787.177 1216.79 785.388 1219.9 783.622C1233.97 775.617 1247.27 768.074 1259.96 759.737L1259.97 759.708Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1013.44 786.765C994.075 786.765 972.667 785.523 948.834 782.841C897.636 777.072 832.625 776.49 818.01 776.66C777.442 777.121 748.297 779.761 724.882 781.89C698.099 784.317 678.74 786.084 657.63 783.345C635.69 780.492 612.871 772.835 581.323 757.735C534.84 735.504 495.988 740.244 458.405 744.835C447.591 746.155 437.38 747.404 426.942 748.042C406.909 749.277 379.644 748.191 352.152 745.09C318.625 741.308 286.204 734.723 258.4 726.045C234.418 718.558 220.959 707.95 217.243 693.63C211.769 672.513 207.117 662.238 192.523 653.297C176.597 643.54 147.977 635.805 100.736 624.941C63.5785 616.405 41.6031 607.343 29.4986 595.585C18.0606 584.48 16.0751 571.473 13.7847 556.409C11.3879 540.727 8.67905 522.958 -4.31188 500.5C-30.5916 455.071 -17.1114 442.093 7.35301 418.527C17.3373 408.926 29.761 396.955 41.9719 380.06C72.8395 337.349 79.1222 334.674 109.323 321.816C120.854 316.913 136.638 310.193 158.791 299.003C177.504 289.544 188.758 281.128 198.7 273.706C208.486 266.397 217.725 259.499 232.092 253.099C254.174 243.271 276.723 238.637 305.258 232.762C326.234 228.455 350.003 223.573 378.97 215.512C386.763 213.347 394.209 211.183 401.407 209.097C440.039 197.892 473.403 188.206 535.386 184.41C582.301 181.536 613.445 182.231 638.47 182.785C696.964 184.084 726.329 184.736 859.046 138.109C917.739 117.488 962.874 112.606 1015.14 106.95C1040.93 104.155 1067.61 101.274 1099.43 96.3135C1105.09 95.4266 1110.46 94.5821 1115.59 93.7732C1174.41 84.4491 1201.26 80.1986 1264.91 92.5598C1275.87 94.6886 1285.83 96.6116 1294.93 98.3714C1375.9 114.018 1388.34 116.424 1419.56 129.523C1440.5 138.307 1458.93 145.779 1475.2 152.372C1519.66 170.388 1549.03 182.295 1569.39 196.934C1589.33 211.261 1601.62 228.824 1613.28 259.577C1632 308.944 1636.47 343.615 1627.33 368.706C1618.94 391.754 1600.42 404.775 1578.95 419.84C1576.62 421.472 1574.26 423.125 1571.89 424.828C1554.69 437.055 1546.38 448.507 1545.72 460.833C1545.15 471.754 1550.6 481.929 1556.39 492.687C1564.95 508.66 1573.8 525.165 1562.83 545.162C1555 559.431 1540.28 568.663 1527.29 576.824C1525.17 578.151 1523.17 579.407 1521.25 580.655C1521.1 580.741 1520.92 580.819 1520.77 580.847C1520.66 580.932 1520.56 581.01 1520.42 581.06C1517.75 582.195 1515.15 583.402 1512.61 584.572C1509.69 585.935 1506.68 587.326 1503.54 588.624C1484.19 596.636 1461.54 601.134 1435.31 606.329C1384.34 616.44 1320.91 629.014 1252.08 675.45C1236.27 686.102 1222.25 698.456 1208.67 710.412C1165.93 748.035 1121.94 786.751 1013.42 786.751L1013.44 786.765ZM822.96 773.793C843.956 773.793 902.316 774.73 949.167 780.017C972.816 782.685 994.083 783.905 1013.31 783.905C1120.95 783.905 1164.48 745.573 1206.81 708.291C1220.45 696.277 1234.57 683.859 1250.51 673.102C1319.82 626.354 1383.56 613.716 1434.8 603.561C1460.88 598.388 1483.39 593.925 1502.49 586.006C1505.57 584.743 1508.55 583.352 1511.44 582.011C1513.99 580.833 1516.63 579.605 1519.34 578.456C1519.42 578.413 1519.51 578.392 1519.61 578.371C1519.65 578.335 1519.69 578.307 1519.73 578.271C1521.68 577.015 1523.68 575.752 1525.8 574.425C1538.49 566.456 1552.89 557.423 1560.37 543.799C1570.6 525.165 1562.11 509.355 1553.91 494.049C1542.46 472.74 1530.65 450.7 1570.26 422.522C1572.63 420.826 1575.01 419.166 1577.34 417.519C1598.41 402.731 1616.6 389.952 1624.67 367.748C1633.56 343.324 1629.09 309.292 1610.64 260.606C1588.13 201.213 1563.97 191.428 1474.14 155.018C1457.88 148.426 1439.43 140.947 1418.46 132.155C1387.53 119.17 1375.12 116.771 1294.4 101.174C1285.31 99.4216 1275.34 97.4915 1264.39 95.3698C1201.22 83.1009 1176.27 87.0462 1116.04 96.5974C1110.92 97.4063 1105.55 98.2578 1099.87 99.1448C1067.99 104.119 1041.28 107.007 1015.44 109.803C963.357 115.444 918.392 120.305 860.004 140.819C747.311 180.415 708.807 186.042 663.998 186.042C655.843 186.042 647.483 185.857 638.42 185.652C613.445 185.098 582.365 184.403 535.571 187.27C473.906 191.045 440.684 200.688 402.215 211.857C395.01 213.95 387.558 216.108 379.743 218.279C350.684 226.361 326.865 231.257 305.847 235.579C277.475 241.412 255.06 246.017 233.269 255.724C219.186 261.99 210.492 268.49 200.423 276.012C190.396 283.505 179.022 291.999 160.089 301.571C137.851 312.818 122.016 319.545 110.451 324.47C80.1575 337.356 74.6974 339.691 44.2907 381.763C31.9379 398.85 19.4079 410.92 9.34562 420.613C-14.8493 443.902 -26.9964 455.596 -1.82999 499.095C11.4304 522.014 14.3094 540.854 16.6211 555.997C21.2232 586.176 24.003 604.399 101.403 622.202C201.444 645.2 209.542 652.523 220.03 692.942C223.476 706.24 236.318 716.174 259.279 723.362C318.462 741.812 387.6 747.631 426.807 745.225C437.153 744.586 447.329 743.345 458.093 742.025C496.08 737.391 535.351 732.594 582.585 755.181C647.192 786.098 671.472 783.891 724.655 779.073C748.12 776.944 777.335 774.29 818.003 773.822C819.279 773.808 820.96 773.8 822.974 773.8L822.96 773.793Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    d: "M704.297 718.977C666.643 718.977 630.89 709.064 599.022 700.216C572.012 692.722 546.498 685.655 523.431 685.399C508.639 685.25 492.053 688.897 472.864 693.12C448.96 698.392 420.404 704.686 387.416 704.686C378.864 704.686 370.029 704.274 360.888 703.302C330.106 700.017 308.662 693.46 295.317 683.256C283.638 674.315 280.042 664.182 276.873 655.255C275.802 652.233 274.781 649.366 273.519 646.797C261.031 621.358 220.746 612.169 181.788 603.278C174.278 601.56 167.18 599.943 160.224 598.19C113.522 586.467 87.7737 577.377 74.1162 567.791C60.6431 558.332 59.1043 548.447 57.1472 535.916C55.5729 525.804 53.6087 513.201 44.6881 496.76C43.0075 493.659 40.9723 490.395 38.8095 486.939C32.8601 477.424 26.1235 466.631 24.1238 454.709C21.805 440.816 26.3788 428.029 38.1146 415.639C41.3127 412.261 45.0072 408.898 48.9215 405.343C56.977 398.027 66.1033 389.746 74.251 378.272C104.353 335.845 113.295 332.247 156.238 314.876C159.195 313.691 162.309 312.421 165.613 311.087C208.571 293.589 223.725 281.838 235.907 272.393C252.876 259.237 265.137 249.728 338.239 234.621C369.582 228.143 395.138 220.301 419.844 212.723C482.466 193.521 536.549 176.945 655.269 191.095C725.003 199.418 749.354 190.129 786.228 176.072C790.788 174.334 795.503 172.539 800.517 170.687C825.903 161.341 844.914 153.976 860.195 148.058C903.536 131.268 974.19 116.147 1072.16 102.693C1083.89 101.082 1096.57 99.3367 1110.29 97.4491C1113.16 97.0518 1116.02 96.6473 1118.87 96.2428C1141.69 93.0213 1165.3 89.6791 1196.39 90.4809C1246.69 91.7653 1324.66 107.057 1354.16 115.26C1390.57 125.372 1489.8 163.342 1493.44 164.854C1553.07 189.555 1573.45 229.831 1580.05 259.265C1589.17 299.904 1576.85 340.862 1560.64 358.751C1549.91 370.587 1535.64 377.406 1521.85 383.991C1505.15 391.974 1490.72 398.878 1486.08 412.921C1482.21 424.694 1485.84 440.823 1497.18 462.238C1499.72 467 1502.08 471.342 1504.17 475.167C1513.65 492.623 1518.87 502.224 1517.56 510.867C1516.24 519.531 1508.61 526.748 1492.71 540.088C1492.52 540.237 1492.3 540.351 1492.09 540.393C1491.96 540.493 1491.82 540.564 1491.67 540.627C1455.3 554.174 1442.68 555.919 1423.57 558.566C1398.05 562.1 1359.49 567.436 1233.78 605.555C1224.53 608.365 1219.45 610.686 1214.54 612.935C1210.76 614.667 1207.21 616.284 1202.04 618.023C1150.36 635.394 1139.51 651.133 1129.05 666.375C1123.26 674.769 1117.8 682.696 1105.99 690.53C1095.43 697.54 1084.5 702.096 1071.6 704.885C1057 708.049 1039.53 708.922 1018.21 707.588C923.689 701.635 897.502 704.324 854.147 708.787C827.782 711.498 794.964 714.869 736.803 717.452C732.612 717.636 728.357 717.906 724.244 718.154C721.266 718.339 718.182 718.523 715.146 718.693C711.516 718.878 707.899 718.977 704.297 718.977ZM522.474 682.554H523.459C546.895 682.802 572.587 689.933 599.781 697.469C634.485 707.091 673.826 718.005 714.998 715.841C718.018 715.692 721.096 715.493 724.067 715.309C728.187 715.046 732.456 714.791 736.675 714.599C794.751 712.03 827.52 708.66 853.856 705.956C897.36 701.471 923.64 698.775 1018.39 704.736C1057.46 707.212 1083.19 702.238 1104.42 688.152C1115.77 680.638 1121.08 672.924 1126.7 664.757C1137.45 649.139 1148.56 633.003 1201.14 615.327C1206.16 613.645 1209.65 612.041 1213.35 610.345C1218.35 608.067 1223.51 605.697 1232.95 602.838C1358.88 564.668 1397.57 559.297 1423.17 555.756C1442.09 553.13 1454.59 551.406 1490.68 537.966C1490.76 537.931 1490.82 537.924 1490.89 537.902C1506.23 525.052 1513.57 518.147 1514.74 510.448C1515.92 502.77 1510.86 493.453 1501.67 476.551C1499.58 472.719 1497.23 468.362 1494.69 463.579C1482.95 441.447 1479.25 424.587 1483.4 412.034C1488.4 396.849 1504.05 389.363 1520.63 381.437C1534.17 374.965 1548.18 368.266 1558.53 356.849C1566.45 348.107 1573.16 333.745 1576.93 317.452C1580.01 304.19 1582.57 283.434 1577.29 259.904C1570.83 231.123 1550.85 191.726 1492.35 167.493C1488.72 165.982 1389.72 128.097 1353.4 118.013C1324 109.846 1246.37 94.6178 1196.31 93.3335C1165.45 92.5458 1141.98 95.8596 1119.27 99.067C1116.41 99.4715 1113.55 99.8689 1110.68 100.273C1096.95 102.168 1084.27 103.906 1072.54 105.517C974.8 118.943 904.359 134.01 861.217 150.719C845.928 156.637 826.903 164.009 801.495 173.362C796.489 175.207 791.787 177.002 787.235 178.733C749.971 192.947 725.358 202.327 654.929 193.926C536.805 179.84 482.983 196.338 420.673 215.441C395.897 223.041 370.277 230.896 338.807 237.403C266.349 252.375 254.309 261.721 237.645 274.635C225.327 284.194 210.003 296.079 166.677 313.713C163.379 315.054 160.259 316.317 157.302 317.516C113.99 335.015 106.182 338.165 76.5627 379.904C68.2448 391.633 58.998 400.028 50.8361 407.45C46.9643 410.963 43.3053 414.291 40.1852 417.583C15.2812 443.895 29.6691 466.915 41.2276 485.428C43.4117 488.905 45.4681 492.212 47.1983 495.391C56.3459 512.272 58.3527 525.137 59.9623 535.476C63.8128 560.191 65.5714 571.481 160.919 595.422C167.84 597.161 174.924 598.772 182.419 600.489C222.03 609.522 262.981 618.875 276.071 645.534C277.404 648.245 278.447 651.182 279.553 654.298C285.708 671.647 293.374 693.247 361.179 700.457C405.137 705.133 442.344 696.937 472.24 690.345C491.188 686.151 507.596 682.547 522.474 682.547V682.554Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M707.907 667.602C704.801 667.602 701.688 667.56 698.568 667.46C653.213 665.992 612.609 654.865 576.778 645.044C563.035 641.262 550.058 637.707 537.706 634.933C498.626 626.141 476.013 632.229 449.833 639.275C433.034 643.803 415.66 648.465 392.097 649.699C390.331 649.799 388.629 649.841 386.998 649.841C359.109 649.841 348.954 636.834 337.296 621.904C329.688 612.176 321.809 602.085 307.96 593.833C288.297 582.089 267.782 578.505 239.368 573.524C219.009 569.969 193.673 565.541 162.153 556.693C110.87 542.316 106.48 528.94 99.8361 508.71C97.9924 503.061 95.8934 496.675 92.5038 489.593C89.7454 483.824 86.2778 478.027 82.9308 472.4C78.1727 464.431 73.2585 456.178 70.1739 447.784C67.0396 439.219 66.3092 432.272 67.8976 425.9C70.4788 415.518 78.0876 408.096 89.6036 396.863C97.1911 389.476 106.636 380.259 117.677 367.308L119.28 365.421C139.149 342.075 166.587 324.444 201.594 312.528C205.919 311.045 210.606 309.448 215.698 307.702C250.629 295.71 264.237 283.817 276.235 273.322C285.638 265.098 294.523 257.335 311.988 251.048C320.568 247.969 328.184 246.145 339.714 243.385C350.28 240.858 364.739 237.403 386.197 231.378C397.039 228.334 408.888 224.197 421.426 219.819C445.741 211.332 473.29 201.71 505.64 195.529C543.137 188.355 579.763 187.27 617.623 192.208C649.065 196.317 670.494 200.773 687.704 204.357C746.341 216.562 747.461 216.803 901.289 145.588C920.612 136.647 944.672 125.506 1053.32 109.732C1063.26 108.292 1073.31 106.73 1083.03 105.219C1100.67 102.473 1118.92 99.6416 1137.17 97.4064C1202.51 89.4447 1295.14 103.076 1346.95 120.866C1369.15 128.494 1388.31 134.561 1405.22 139.918C1439.82 150.882 1464.81 158.808 1484.47 170.268C1530.21 196.956 1542.05 251.417 1532.75 278.85C1528.41 291.637 1519.37 303.565 1510.22 314.55C1501.88 324.598 1488.27 331.041 1468.64 334.284C1438.42 339.272 1416.87 340.897 1402.62 341.962C1389.99 342.912 1381.65 343.537 1380.65 345.793C1379.71 347.908 1384.14 353.691 1390.88 362.448C1402.6 377.697 1424.43 406.088 1449.4 456.171C1454.45 466.29 1456.72 472.137 1456.01 478.034C1455.3 483.923 1451.52 489.451 1442.53 497.746C1442.34 497.938 1442.1 498.059 1441.84 498.101C1441.78 498.165 1441.7 498.222 1441.6 498.264C1427.6 505.374 1408.8 510.491 1385.73 513.492C1315.17 522.66 1314.65 522.781 1287.56 529.338C1281.87 530.707 1274.79 532.424 1265.67 534.567C1256.26 536.76 1246.94 538.442 1237.91 540.067C1227.08 542.032 1216.85 543.877 1206.72 546.517C1191.39 550.505 1181.61 552.286 1172.16 554.01C1164.65 555.38 1157.55 556.678 1148.14 558.992C1096.73 571.672 1080.45 584.892 1063.21 598.885C1056.92 603.994 1050.42 609.274 1042.12 614.461C1009.28 634.961 969.442 635.273 930.93 635.592C905.529 635.777 879.271 635.99 855.409 642.021C850.757 643.199 846.028 644.42 841.234 645.655C801.098 655.979 755.928 667.602 707.928 667.602H707.907ZM501.626 627.787C512.419 627.787 524.41 629.029 538.323 632.151C550.746 634.961 563.751 638.516 577.529 642.291C613.205 652.069 653.638 663.16 698.66 664.608C749.73 666.247 797.957 653.85 840.511 642.894C845.311 641.66 850.041 640.446 854.7 639.254C878.888 633.151 905.324 632.932 930.901 632.74C969.023 632.435 1008.45 632.137 1040.6 612.041C1048.76 606.939 1055.19 601.723 1061.41 596.678C1078.14 583.104 1095.44 569.047 1147.48 556.224C1156.94 553.89 1164.09 552.584 1171.66 551.2C1181.06 549.497 1190.78 547.709 1206.03 543.757C1216.26 541.103 1226.53 539.229 1237.42 537.278C1246.39 535.646 1255.69 533.964 1265.02 531.793C1274.13 529.664 1281.2 527.947 1286.9 526.563C1314.13 519.985 1314.64 519.857 1385.37 510.661C1408.11 507.702 1426.59 502.678 1440.31 495.724C1440.42 495.667 1440.55 495.625 1440.68 495.596C1456.54 480.915 1456.11 475.99 1446.87 457.448C1422 407.606 1401.12 380.422 1388.63 364.186C1380.24 353.265 1376.42 348.298 1378.05 344.637C1379.76 340.826 1386.39 340.315 1402.42 339.116C1416.61 338.059 1438.09 336.441 1468.19 331.467C1487.11 328.344 1500.15 322.214 1508.05 312.712C1517.01 301.94 1525.89 290.268 1530.07 277.921C1534.72 264.183 1533.46 244.158 1526.74 225.659C1520.99 209.778 1508.72 187.702 1483.04 172.723C1463.67 161.419 1438.8 153.535 1404.37 142.622C1387.46 137.264 1368.27 131.183 1346.04 123.548C1294.53 105.865 1202.46 92.3115 1137.54 100.223C1119.31 102.445 1101.1 105.276 1083.49 108.015C1073.77 109.533 1063.69 111.095 1053.74 112.542C945.495 128.26 921.654 139.301 902.494 148.164C793.532 198.602 760.757 213.397 730.095 213.397C717.232 213.397 704.737 210.793 687.144 207.131C669.976 203.555 648.611 199.106 617.275 195.018C532.699 183.984 471.538 205.336 422.39 222.501C409.803 226.893 397.918 231.045 386.991 234.11C365.484 240.142 350.989 243.612 340.402 246.145C328.964 248.877 321.412 250.693 312.974 253.73C296.012 259.833 287.729 267.085 278.135 275.465C265.931 286.124 252.104 298.222 216.648 310.399C211.55 312.151 206.869 313.734 202.537 315.217C168.027 326.977 141.009 344.329 121.485 367.273L119.876 369.16C108.757 382.21 99.2546 391.477 91.6245 398.907C80.0589 410.182 73.0742 417.001 70.6915 426.588C69.2591 432.385 69.947 438.807 72.8827 446.79C75.8751 454.944 80.7255 463.083 85.4127 470.945C88.7952 476.615 92.2911 482.49 95.1134 488.365C98.5809 495.625 100.701 502.103 102.58 507.83C109.168 527.89 113.139 539.996 162.961 553.961C194.347 562.752 219.605 567.173 239.9 570.721C268.605 575.745 289.346 579.371 309.457 591.378C323.767 599.914 332.162 610.671 339.58 620.152C351.918 635.954 361.654 648.422 391.983 646.84C415.249 645.64 432.481 640.992 449.13 636.515C465.667 632.066 481.608 627.78 501.669 627.78L501.626 627.787Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("path", {
    d: "M697.901 619.421C687.08 619.421 676.16 618.641 665.083 617.087C631.457 612.368 600.767 601.121 573.693 591.194C555.944 584.694 539.195 578.541 523.296 574.766C489.245 566.641 462.951 569.849 441.827 572.432C427.318 574.213 414.788 575.738 403.222 573.34C395.904 571.814 387.083 567.472 375.922 561.958C352.755 550.534 321.029 534.866 275.334 530.615C225.065 525.925 194.275 521.532 175.569 511.69C157.551 502.203 149.97 487.713 137.398 463.665C136.001 460.997 134.54 458.201 132.994 455.27C131.399 452.269 129.768 449.437 128.186 446.691C121.357 434.862 115.458 424.658 119.344 410.53C123.471 395.515 138.27 377.52 167.343 352.18C192.439 330.296 219.527 322.434 245.729 314.806C260.599 310.477 275.972 306 290.807 299.024C306.117 291.801 314.151 283.945 322.653 275.629C331.687 266.795 341.033 257.655 359.626 249.566C376.539 242.207 396.011 236.225 414.838 230.449C419.298 229.079 423.907 227.66 428.396 226.255C436.6 223.687 445.032 220.735 453.959 217.605C503.611 200.22 565.418 178.585 647.561 204.57C661.97 209.126 674.869 214.888 687.349 220.458C729.428 239.241 765.77 255.469 830.158 207.018C872.258 175.342 958.436 137.967 975.348 132.731C992.218 127.494 1030.5 119.085 1068.4 112.259C1095.61 107.362 1146.19 99.0673 1179.19 98.5067C1255.4 97.2223 1315.48 119.66 1379.06 143.417C1386.24 146.092 1393.65 148.86 1401.06 151.592L1403 152.301C1412.98 155.963 1423.27 159.752 1431.54 164.556C1447.12 173.625 1456.66 187.618 1459.11 205.017C1461.14 219.386 1458.1 235.92 1450.79 250.382C1448.74 254.412 1438.43 258.826 1428.65 258.279C1423.94 258.01 1417.51 256.505 1409.39 254.597C1380.3 247.735 1331.61 236.282 1270.05 259.124C1256.63 264.105 1240.31 272.904 1238.71 286.592C1237.16 299.954 1249.58 315.53 1275.65 332.901C1288.51 341.465 1298.6 347.518 1307.48 352.854C1335.35 369.594 1346.88 376.534 1373.52 420.713C1378.48 428.923 1382.76 439.723 1372.01 450.523C1371.82 450.736 1371.56 450.871 1371.29 450.921C1371.2 450.999 1371.1 451.062 1370.98 451.112C1368.77 452.162 1367.18 452.993 1365.77 453.738C1360.83 456.321 1358.79 457.385 1343.77 460.152C1308.91 466.603 1291.91 468.277 1276.89 469.767C1249.69 472.457 1228.22 474.586 1120.9 501.536C1114.04 503.253 1108.06 504.616 1102.29 505.921C1085.22 509.789 1071.74 512.854 1049.42 522.235C1013.31 537.435 997.515 548.107 985.971 555.891C971.186 565.882 963.754 570.892 930.681 573.823C909.231 575.724 893.722 576.888 881.263 577.818C854.364 579.847 829.713 585.129 807.31 593.663C799.51 596.622 789.795 600.319 777.378 604.896C751.021 614.596 724.776 619.414 697.901 619.414V619.421ZM479.388 566.72C492.613 566.72 507.37 568.039 523.963 571.992C540.017 575.824 556.852 581.997 574.672 588.518C630.805 609.104 694.412 632.414 776.393 602.235C788.795 597.665 798.503 593.968 806.296 591.002C828.954 582.383 853.87 577.047 881.043 574.993C893.488 574.057 908.99 572.879 930.419 570.998C962.769 568.139 969.987 563.257 984.382 553.535C996.005 545.694 1011.94 534.923 1048.32 519.617C1070.85 510.129 1084.45 507.057 1101.65 503.154C1107.41 501.848 1113.37 500.486 1120.21 498.776C1227.71 471.768 1249.29 469.647 1276.61 466.929C1291.56 465.453 1308.52 463.778 1343.25 457.371C1357.84 454.667 1359.64 453.731 1364.44 451.211C1365.88 450.466 1367.49 449.601 1369.77 448.529C1369.87 448.487 1369.98 448.444 1370.08 448.43C1377.39 441.007 1377.7 433.145 1371.08 422.175C1344.82 378.599 1334.25 372.262 1306.02 355.302C1297.54 350.215 1286.99 343.864 1274.08 335.263C1247.04 317.268 1234.2 300.77 1235.89 286.259C1237.28 274.302 1248.76 263.999 1269.06 256.456C1331.43 233.316 1380.63 244.896 1410.03 251.822C1418.02 253.71 1424.34 255.193 1428.82 255.441C1437.92 255.959 1446.99 251.574 1448.25 249.097C1461.72 222.487 1461.79 185.461 1430.12 167.025C1422.06 162.342 1411.88 158.602 1402.03 154.983L1400.09 154.274C1392.65 151.535 1385.23 148.767 1378.07 146.092C1314.74 122.434 1254.92 100.061 1179.25 101.359C1123.4 102.31 1006.53 126.053 976.192 135.448C959.372 140.657 873.711 177.804 831.867 209.296C799.666 233.529 774.343 241.916 751.85 241.916C729.357 241.916 708.077 232.826 686.187 223.055C673.784 217.52 660.963 211.794 646.703 207.288C565.46 181.579 504.15 203.044 454.903 220.295C445.954 223.424 437.501 226.39 429.254 228.966C424.758 230.378 420.142 231.79 415.682 233.16C396.926 238.914 377.531 244.861 360.768 252.156C342.65 260.039 333.503 268.994 324.653 277.644C316.349 285.769 307.776 294.149 292.034 301.572C277 308.668 261.514 313.174 246.537 317.524C220.633 325.059 193.857 332.851 169.23 354.316C141 378.932 126.023 397.027 122.109 411.275C118.542 424.247 123.896 433.514 130.675 445.258C132.271 448.025 133.916 450.885 135.533 453.929C137.079 456.867 138.546 459.656 139.943 462.331C165.096 510.434 168.96 517.828 275.625 527.756C321.845 532.077 353.847 547.858 377.205 559.397C388.189 564.818 396.869 569.097 403.832 570.544C414.937 572.858 427.254 571.346 441.514 569.608C452.605 568.245 465.114 566.712 479.417 566.712L479.388 566.72Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M684.577 555.742C678.181 555.742 671.834 555.351 665.466 554.578C636.272 550.98 610.943 539.378 586.443 528.181C570.871 521.064 554.774 513.698 537.585 508.277C512.624 500.393 492.507 500.209 471.205 499.989C447.258 499.762 420.121 499.506 381.985 487.805C334.006 473.081 328.574 472.641 298.43 470.143C288.432 469.32 275.979 468.284 258.408 466.46C239.432 464.473 225.838 459.698 214.343 451.005C202.608 442.128 192.482 428.454 182.504 407.982C178.469 399.694 178.512 391.122 182.632 381.77C186.326 373.397 192.843 365.322 199.204 357.757C210.33 344.537 224.413 334.22 242.254 326.23C257.933 319.198 274.434 314.798 290.389 310.548C313.002 304.509 334.368 298.818 349.975 286.429C359.066 279.226 366.122 273.358 372.341 268.171C395.068 249.26 403.57 242.185 442.982 228.043C512.943 202.945 551.392 190.2 592.825 197.694C631.507 204.69 647.646 222.132 663.261 238.992C680.081 257.151 695.958 274.302 738.732 278.353C822.173 286.258 858.884 246.613 885.703 217.662C891.595 211.297 897.169 205.279 902.501 200.674C909.032 195.033 931.086 179.251 955.515 164.307C977.816 150.662 1009.61 133.064 1034.47 126.691L1038.25 125.726C1080.27 114.955 1116.56 105.652 1152.18 102.246C1191.04 98.5347 1225.75 102.416 1261.4 114.458C1268.97 117.013 1294 126.315 1298.84 138.847C1300.07 142.019 1299.87 145.098 1298.24 148.008C1294.6 154.515 1285.07 159.368 1277.17 162.86C1240.53 179.102 1216.38 182.785 1190.82 186.681C1169.03 189.995 1146.5 193.429 1114.11 204.79C1112.16 205.471 1110.36 206.074 1108.7 206.642C1098.8 209.984 1093.83 211.666 1089.72 217.967C1080.13 232.698 1089.66 239.978 1121.22 264.091C1127.75 269.079 1135.17 274.742 1143.49 281.32C1164.4 297.803 1188.53 311.889 1209.83 324.307C1242.69 343.466 1268.64 358.616 1270.18 374.504C1270.74 380.379 1268.01 385.886 1261.81 391.335C1261.62 391.499 1261.39 391.619 1261.16 391.662C1261.09 391.719 1261.01 391.768 1260.93 391.811C1249.37 398.041 1233.62 401.468 1218.33 404.243C1174.22 412.226 1160.28 416.363 1135.01 423.849C1124.35 427.014 1112.29 430.59 1095.17 435.302C1077.63 440.127 1057.63 444.917 1038.3 449.536C996.168 459.613 952.621 470.03 927.363 482.341C903.856 493.801 885.965 497.981 865.252 502.82C841.227 508.426 813.997 514.798 770.855 534.546C750.383 543.898 731.527 550.015 713.204 553.208C703.454 554.904 693.987 555.749 684.605 555.749L684.577 555.742ZM569.027 198.403C535.869 198.403 500.165 210.544 443.94 230.711C405.002 244.683 397.231 251.148 374.163 270.356C367.923 275.543 360.86 281.426 351.741 288.657C335.665 301.401 314.023 307.184 291.112 313.287C258.925 321.873 225.647 330.75 201.381 359.595C187.766 375.774 177.136 390.491 185.057 406.748C203.955 445.506 222.534 459.847 258.691 463.629C276.242 465.467 288.673 466.489 298.664 467.312C329.064 469.831 334.538 470.285 382.814 485.094C420.553 496.661 446.308 496.909 471.226 497.157C492.748 497.363 513.071 497.555 538.436 505.559C555.788 511.044 571.977 518.445 587.62 525.605C638.01 548.646 685.598 570.409 769.642 531.956C813.047 512.094 840.419 505.701 864.578 500.06C885.128 495.256 902.863 491.105 926.094 479.786C951.636 467.34 995.338 456.888 1037.6 446.776C1056.92 442.157 1076.89 437.381 1094.39 432.563C1111.48 427.851 1123.52 424.275 1134.16 421.124C1159.54 413.61 1173.52 409.458 1217.79 401.447C1232.86 398.722 1248.34 395.366 1259.55 389.32C1259.67 389.242 1259.81 389.199 1259.94 389.171C1265.38 384.395 1267.79 379.684 1267.32 374.802C1265.93 360.361 1239.25 344.807 1208.37 326.79C1187 314.316 1162.77 300.188 1141.71 283.576C1133.39 277.019 1126 271.357 1119.47 266.383C1103.48 254.163 1092.91 246.088 1087.52 238.935C1081.86 231.428 1081.79 224.914 1087.31 216.441C1091.96 209.31 1097.58 207.408 1107.75 203.966C1109.41 203.406 1111.21 202.803 1113.14 202.129C1145.78 190.69 1168.44 187.234 1190.37 183.892C1215.73 180.025 1239.71 176.377 1276 160.284C1283.49 156.97 1292.5 152.421 1295.73 146.645C1296.94 144.481 1297.07 142.274 1296.16 139.897C1292.68 130.864 1275.44 122.235 1260.47 117.19C1183.93 91.3394 1123.1 106.936 1038.91 128.515L1035.13 129.48C987.864 141.593 914.053 194.451 904.331 202.859C899.119 207.365 893.602 213.319 887.752 219.627C874.647 233.77 858.345 251.382 834.937 264.197C807.53 279.198 775.967 284.775 738.441 281.22C718.77 279.354 702.815 274.493 689.668 266.347C677.911 259.06 669.395 249.856 661.162 240.951C645.867 224.431 630.053 207.351 592.307 200.518C584.535 199.106 576.842 198.432 569.02 198.432L569.027 198.403Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("path", {
    d: "M681.499 474.514C675.905 474.514 670.395 474.138 664.913 473.379C641.35 470.15 620.324 460.5 593.704 448.273C587.677 445.506 581.444 442.646 574.849 439.709C552.923 429.945 521.176 426.922 487.557 423.7C463.802 421.429 439.238 419.088 418.504 414.121C408.25 411.673 403.45 410.353 399.202 409.182C390.522 406.798 385.289 405.357 341.977 396.686C340.459 396.374 338.949 396.083 337.438 395.77C302.72 388.859 269.924 382.324 263.024 359.347C259.422 347.369 266.357 334.625 283.085 322.49C289.8 317.616 296.14 313.032 348.557 296.548C389.047 283.803 404.91 268.895 418.901 255.753C427.304 247.869 435.239 240.411 447.429 233.975C453.676 230.676 484.763 216.25 511.724 211.226C569.906 200.39 587.875 219.23 612.73 245.308C615.488 248.203 618.339 251.197 621.338 254.242C658.12 291.616 712.374 288.778 769.805 285.769C776.634 285.421 783.69 285.059 790.717 284.74C858.239 281.845 891.446 276.076 915.691 271.875C934.631 268.582 947.147 266.411 965.293 267.703C999.317 270.144 1055.56 281.334 1079.91 292.652C1082.96 294.064 1086.38 295.341 1089.7 296.583C1096.76 299.244 1104.07 301.976 1108.8 306.347C1116.04 313.032 1121.14 318.197 1120.9 323.825C1120.72 328.167 1117.5 332.453 1110.16 338.18C1107.18 340.5 1104 342.806 1100.92 345.041C1099.56 346.028 1098.2 347.007 1096.85 348.015C1096.68 348.135 1096.48 348.206 1096.27 348.249C1096.17 348.348 1096.03 348.433 1095.88 348.476L1093.63 349.342C1083.72 353.081 1073.46 356.956 1062.78 360.326C1052.83 363.477 1041.64 366.485 1027.54 369.764C1007.92 374.369 987.311 378.158 967.385 381.827C961.308 382.948 955.018 384.105 948.849 385.276C927.533 389.306 900.034 395.146 876.491 404.655C874.236 405.57 872.002 406.542 869.84 407.465C866.925 408.728 863.919 410.026 860.791 411.225L858.551 412.077C853.97 413.83 849.233 415.632 844.957 417.647C824.407 427.291 812.997 432.726 806.183 435.976C799.933 438.942 796.154 440.624 794.844 441.021C792.312 441.802 786.384 443.59 749.014 458.932C723.295 469.497 701.794 474.507 681.485 474.507L681.499 474.514ZM541.549 210.985C533.068 210.985 523.424 211.942 512.256 214.022C485.643 218.982 454.938 233.223 448.762 236.487C436.905 242.739 429.112 250.062 420.851 257.818C406.633 271.18 390.515 286.315 349.408 299.251C297.43 315.607 291.268 320.064 284.751 324.79C268.874 336.313 262.478 347.66 265.747 358.524C272.157 379.868 304.138 386.226 337.991 392.982C339.502 393.287 341.019 393.585 342.537 393.89C385.942 402.583 391.217 404.044 399.954 406.443C404.173 407.599 408.959 408.905 419.171 411.36C439.706 416.278 464.171 418.619 487.827 420.876C521.68 424.105 553.654 427.163 576.005 437.112C582.614 440.063 588.854 442.923 594.889 445.691C647.561 469.874 679.351 484.477 747.943 456.306C785.441 440.915 791.462 439.091 794.029 438.311C795.206 437.956 798.855 436.324 804.977 433.415C811.792 430.165 823.201 424.729 843.759 415.071C848.127 413.007 852.92 411.197 857.551 409.423L859.792 408.572C862.855 407.394 865.833 406.095 868.726 404.853C870.91 403.924 873.158 402.952 875.435 402.036C899.218 392.421 926.881 386.539 948.338 382.487C954.501 381.323 960.783 380.166 966.875 379.038C986.765 375.362 1007.34 371.573 1026.92 367.003C1040.93 363.732 1052.07 360.738 1061.93 357.615C1072.55 354.259 1082.76 350.413 1092.64 346.674L1094.9 345.822C1094.98 345.801 1095.04 345.765 1095.11 345.758C1095.13 345.751 1095.15 345.723 1095.17 345.716C1096.53 344.722 1097.9 343.729 1099.27 342.735C1102.32 340.521 1105.48 338.244 1108.42 335.937C1114.95 330.85 1117.92 327.082 1118.06 323.718C1118.23 319.666 1114.59 315.565 1106.87 308.433C1102.55 304.445 1095.51 301.799 1088.71 299.251C1085.34 297.995 1081.85 296.69 1078.71 295.235C1054.63 284.03 998.863 272.961 965.102 270.541C947.303 269.264 934.922 271.414 916.18 274.678C891.858 278.893 858.558 284.683 790.845 287.585C783.831 287.891 776.783 288.252 769.968 288.614C740.384 290.161 712.445 291.616 686.903 287.954C658.021 283.803 636.556 273.727 619.324 256.228C616.311 253.163 613.453 250.168 610.688 247.266C591.222 226.851 576.09 210.985 541.556 210.985H541.549Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676.28 427.652C654.411 427.652 638.52 420.18 613.531 408.422C607.511 405.584 600.689 402.377 593.222 399.013C566.325 386.915 539.322 384.53 510.738 382.011C470.985 378.492 425.935 374.518 371.929 342.934C360.101 336.022 358.981 322.299 363.122 311.783C365.767 305.063 370.568 301.976 376.645 298.052C378.042 297.144 379.489 296.214 380.999 295.171C402.336 280.553 418.39 267.532 432.566 256.037C457.314 235.969 475.197 221.465 500.789 216.299C556.533 205.031 579.487 231.683 599.732 255.199C608.227 265.063 616.254 274.373 625.983 279.872C632.415 283.498 641.633 286.166 654.17 288.018C677.883 291.509 703.056 291.474 727.407 291.453C730.357 291.438 733.293 291.438 736.236 291.438C751.801 291.46 767.508 291.339 780.811 291.233C792.837 291.126 808.657 291.133 824.293 292.162C857.125 294.334 885.249 293.965 910.302 291.027C933.241 288.337 952.763 292.623 967.208 296.647C967.421 296.711 967.619 296.817 967.768 296.959C968.038 297.023 968.286 297.172 968.491 297.399C969.009 298.002 969.569 298.598 970.172 299.223C972.15 301.33 974.2 303.487 974.887 305.971C975.632 308.703 974.973 311.719 972.966 314.72C970.718 318.098 966.853 320.496 960.833 322.249C959.486 322.639 958.145 323.037 956.819 323.434C952.253 324.775 947.537 326.166 942.743 327.408C936.042 329.168 929.682 330.544 923.271 331.602C920.321 332.098 917.293 332.545 914.365 332.985C910.741 333.517 907.004 334.085 903.374 334.717C890.191 337.016 878.264 340.11 867.961 343.92C862.252 346.035 857.281 348.27 853.19 350.597C850.715 351.988 848.332 353.478 846.028 354.926C844.127 356.111 842.163 357.332 840.142 358.524C839.383 358.964 838.632 359.396 837.873 359.843C834.122 362.029 830.243 364.286 826.924 366.663C825.194 367.919 823.499 369.203 821.861 370.452C819.748 372.063 817.564 373.723 815.266 375.327C806.353 381.515 796.163 387.12 788.278 391.314C785.143 393.003 782.009 394.749 778.981 396.437C772.663 399.971 766.132 403.618 759.027 406.861C750.347 410.807 740.037 414.518 726.585 418.513C705.276 424.864 689.654 427.66 676.273 427.66L676.28 427.652ZM525.339 216.512C518.099 216.512 510.15 217.314 501.357 219.095C476.453 224.126 458.796 238.439 434.36 258.258C420.149 269.782 404.038 282.852 382.609 297.534C381.063 298.591 379.602 299.542 378.184 300.45C372.319 304.24 368.079 306.964 365.767 312.833C362.073 322.228 362.995 334.426 373.369 340.486C426.822 371.758 471.538 375.696 510.993 379.187C539.826 381.727 567.063 384.147 594.399 396.423C601.895 399.794 608.73 403.015 614.758 405.854C654.333 424.488 670.714 432.187 725.791 415.788C739.122 411.814 749.312 408.16 757.864 404.264C764.863 401.078 771.344 397.445 777.613 393.947C780.655 392.251 783.789 390.491 786.959 388.802C794.78 384.644 804.878 379.081 813.664 372.978C815.912 371.424 818.074 369.771 820.159 368.181C821.819 366.918 823.527 365.62 825.293 364.349C828.725 361.887 832.668 359.595 836.476 357.381C837.228 356.948 837.979 356.508 838.724 356.076C840.709 354.912 842.659 353.691 844.539 352.513C846.871 351.059 849.282 349.54 851.807 348.114C856.033 345.715 861.146 343.416 866.996 341.245C877.47 337.392 889.553 334.248 902.913 331.914C906.572 331.275 910.337 330.715 913.975 330.175C916.889 329.742 919.903 329.302 922.825 328.806C929.143 327.756 935.432 326.407 942.041 324.669C946.778 323.427 951.487 322.043 956.039 320.702C957.365 320.312 958.706 319.915 960.053 319.538C965.407 317.97 968.761 315.941 970.619 313.145C972.165 310.832 972.689 308.674 972.15 306.737C971.654 304.935 969.853 303.033 968.115 301.195C967.562 300.599 966.995 300.01 966.477 299.4H966.456C952.26 295.433 933.099 291.233 910.642 293.858C885.426 296.817 857.125 297.186 824.123 295.015C808.579 293.979 792.83 293.965 780.846 294.071C767.536 294.192 751.829 294.298 736.243 294.284H727.422C702.971 294.319 677.691 294.341 653.773 290.814C640.881 288.926 631.344 286.145 624.6 282.348C614.439 276.615 606.256 267.106 597.59 257.051C581.061 237.85 562.674 216.505 525.346 216.505L525.339 216.512Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.789 276.012C485.216 276.012 475.551 273.883 466.453 266.993C459.972 262.09 456.93 257.328 457.164 252.425C457.596 243.207 469.701 235.728 482.522 227.802C485.472 225.978 488.521 224.091 491.428 222.182C505.043 213.241 529.444 221.792 539.868 235.061C548.377 245.882 546.93 258.016 535.904 268.327C535.705 268.518 535.464 268.639 535.216 268.696C535.081 268.795 534.932 268.887 534.748 268.944C533.939 269.207 533.117 269.519 532.323 269.81C530.5 270.491 528.628 271.194 526.487 271.548C524.005 271.967 521.502 272.443 518.857 272.953C511.17 274.429 503.008 276.012 494.789 276.012ZM505.114 221.437C500.476 221.437 496.243 222.423 492.995 224.559C490.053 226.489 486.989 228.391 484.018 230.222C471.857 237.736 460.376 244.839 460.007 252.56C459.823 256.448 462.496 260.422 468.176 264.722C484.082 276.764 502.271 273.259 518.318 270.165C520.984 269.647 523.501 269.157 526.019 268.738C527.884 268.426 529.557 267.809 531.33 267.142C532.153 266.837 532.996 266.524 533.869 266.248C533.925 266.226 533.968 266.212 534.025 266.205C547.384 253.631 542.023 242.405 537.634 236.828C530.195 227.369 516.467 221.444 505.114 221.444V221.437Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.5 144.176C1083.78 144.176 1072.05 143.374 1064.76 141.643C1064.53 141.586 1064.32 141.473 1064.16 141.331C1063.97 141.281 1063.79 141.189 1063.62 141.061C1062.97 140.543 1061.02 138.961 1061.32 136.605C1061.77 133.177 1066.1 129.544 1087.56 120.149C1102.17 113.756 1151.14 103.978 1158.78 103.169C1171.33 101.842 1185.01 102.594 1197.29 105.297C1209.09 107.895 1211.4 113.146 1211.74 116.048C1212.32 121.143 1208.09 126.365 1200.43 130.02C1182.16 138.734 1133.16 144.183 1097.5 144.183V144.176ZM1065.45 138.876C1077.29 141.678 1103.44 142.076 1132.06 139.89C1162.67 137.556 1187.77 132.894 1199.2 127.444C1205.61 124.379 1209.33 120.135 1208.92 116.367C1208.5 112.713 1204.04 109.697 1196.66 108.079C1184.68 105.439 1171.33 104.701 1159.08 106C1151.52 106.802 1103.11 116.452 1088.7 122.761C1082.11 125.642 1064.63 133.291 1064.13 136.974C1064.11 137.165 1064.03 137.74 1065.41 138.84C1065.42 138.847 1065.43 138.861 1065.45 138.876Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M1731.75 780.826C1731.75 784.572 1728.71 787.609 1724.97 787.609C1721.23 787.609 1718.18 784.572 1718.18 780.826C1718.18 777.079 1721.21 774.042 1724.97 774.042C1728.73 774.042 1731.75 777.079 1731.75 780.826Z",
    fill: "url(#paint0_radial_75_3609)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M1602.66 173.83C1602.66 175.583 1601.25 177.009 1599.5 177.009C1597.75 177.009 1596.33 175.59 1596.33 173.83C1596.33 172.071 1597.76 170.651 1599.5 170.651C1601.25 170.651 1602.66 172.071 1602.66 173.83Z",
    fill: "url(#paint1_radial_75_3609)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M994.132 19.4075C994.132 21.515 992.431 23.218 990.325 23.218C988.218 23.218 986.517 21.5079 986.517 19.4075C986.517 17.3071 988.218 15.5898 990.325 15.5898C992.431 15.5898 994.132 17.3 994.132 19.4075Z",
    fill: "url(#paint2_radial_75_3609)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M857.047 18.1022C857.047 21.9979 853.891 25.1556 849.998 25.1556C846.105 25.1556 842.942 21.9979 842.942 18.1022C842.942 14.2065 846.098 11.0488 849.998 11.0488C853.898 11.0488 857.047 14.2065 857.047 18.1022Z",
    fill: "url(#paint3_radial_75_3609)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M700.879 53.9653C700.879 56.2006 699.063 58.01 696.837 58.01C694.61 58.01 692.795 56.2006 692.795 53.9653C692.795 51.7301 694.61 49.9277 696.837 49.9277C699.063 49.9277 700.879 51.7372 700.879 53.9653Z",
    fill: "url(#paint4_radial_75_3609)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M503.828 37.1345C504.65 33.359 502.258 29.6315 498.485 28.809C494.712 27.9864 490.987 30.3804 490.165 34.1559C489.343 37.9315 491.735 41.659 495.508 42.4815C499.281 43.304 503.006 40.9101 503.828 37.1345Z",
    fill: "url(#paint5_radial_75_3609)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M224.285 43.7752C224.285 45.2441 223.094 46.4362 221.626 46.4362C220.158 46.4362 218.967 45.2441 218.967 43.7752C218.967 42.3064 220.158 41.1143 221.626 41.1143C223.094 41.1143 224.285 42.3064 224.285 43.7752Z",
    fill: "url(#paint6_radial_75_3609)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M543.733 49.7076C543.733 52.0138 541.868 53.88 539.563 53.88C537.259 53.88 535.394 52.0138 535.394 49.7076C535.394 47.4014 537.259 45.5352 539.563 45.5352C541.868 45.5352 543.733 47.4014 543.733 49.7076Z",
    fill: "url(#paint7_radial_75_3609)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M1691.59 740.655C1691.59 744.629 1688.38 747.837 1684.42 747.837C1680.45 747.837 1677.25 744.629 1677.25 740.655C1677.25 736.682 1680.45 733.481 1684.42 733.481C1688.38 733.481 1691.59 736.703 1691.59 740.655Z",
    fill: "url(#paint8_radial_75_3609)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M1546.84 781.429C1546.84 784.552 1544.31 787.092 1541.19 787.092C1538.07 787.092 1535.55 784.552 1535.55 781.429C1535.55 778.307 1538.09 775.788 1541.19 775.788C1544.3 775.788 1546.84 778.314 1546.84 781.429Z",
    fill: "url(#paint9_radial_75_3609)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M71.4216 775.369C71.4216 779.57 68.025 782.976 63.827 782.976C59.6291 782.976 56.2324 779.577 56.2324 775.369C56.2324 771.161 59.6291 767.776 63.827 767.776C68.025 767.776 71.4216 771.175 71.4216 775.369Z",
    fill: "url(#paint10_radial_75_3609)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M1527.25 736.228C1527.25 740.343 1523.92 743.679 1519.8 743.679C1515.68 743.679 1512.38 740.343 1512.38 736.228C1512.38 732.112 1515.7 728.784 1519.8 728.784C1523.9 728.784 1527.25 732.112 1527.25 736.228Z",
    fill: "url(#paint11_radial_75_3609)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M1653.86 628.554C1653.86 631.343 1651.59 633.606 1648.8 633.606C1646 633.606 1643.75 631.335 1643.75 628.554C1643.75 625.772 1646.02 623.487 1648.8 623.487C1651.58 623.487 1653.86 625.744 1653.86 628.554Z",
    fill: "url(#paint12_radial_75_3609)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M1615.5 212.375C1615.5 214.773 1613.56 216.718 1611.16 216.718C1608.76 216.718 1606.82 214.773 1606.82 212.375C1606.82 209.977 1608.76 208.032 1611.16 208.032C1613.56 208.032 1615.5 209.969 1615.5 212.375Z",
    fill: "url(#paint13_radial_75_3609)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M1357.48 718.402C1357.48 721.404 1355.04 723.845 1352.04 723.845C1349.04 723.845 1346.59 721.404 1346.59 718.402C1346.59 715.401 1349.03 712.945 1352.04 712.945C1355.06 712.945 1357.48 715.372 1357.48 718.402Z",
    fill: "url(#paint14_radial_75_3609)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M156.891 693.638C156.891 696.774 154.359 699.3 151.232 699.3C148.105 699.3 145.573 696.774 145.573 693.638C145.573 690.501 148.105 687.989 151.232 687.989C154.359 687.989 156.891 690.508 156.891 693.638Z",
    fill: "url(#paint15_radial_75_3609)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M68.0394 657.583C68.0394 661.053 65.2242 663.856 61.7495 663.856C58.2749 663.856 55.4668 661.046 55.4668 657.583C55.4668 654.121 58.282 651.282 61.7495 651.282C65.2171 651.282 68.0394 654.092 68.0394 657.583Z",
    fill: "url(#paint16_radial_75_3609)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.8338 388.54C14.8338 391.988 12.047 394.763 8.60784 394.763C5.16865 394.763 2.38184 391.988 2.38184 388.54C2.38184 385.091 5.16865 382.31 8.60784 382.31C12.047 382.31 14.8338 385.105 14.8338 388.54Z",
    fill: "url(#paint17_radial_75_3609)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M1206.89 82.9448C1206.89 84.2575 1205.82 85.3219 1204.5 85.3219C1203.19 85.3219 1202.13 84.2575 1202.13 82.9448C1202.13 81.632 1203.2 80.5605 1204.5 80.5605C1205.81 80.5605 1206.89 81.6249 1206.89 82.9448Z",
    fill: "url(#paint18_radial_75_3609)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M1618.44 463.289C1618.44 465.382 1616.73 467.071 1614.66 467.071C1612.59 467.071 1610.88 465.382 1610.88 463.289C1610.88 461.196 1612.56 459.507 1614.66 459.507C1616.77 459.507 1618.44 461.203 1618.44 463.289Z",
    fill: "url(#paint19_radial_75_3609)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M1379.99 674.358C1379.99 677.26 1377.63 679.616 1374.73 679.616C1371.83 679.616 1369.46 677.26 1369.46 674.358C1369.46 671.455 1371.82 669.1 1374.73 669.1C1377.65 669.1 1379.99 671.455 1379.99 674.358Z",
    fill: "url(#paint20_radial_75_3609)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M1264.79 758.523C1264.79 761.61 1262.28 764.115 1259.2 764.115C1256.11 764.115 1253.6 761.61 1253.6 758.523C1253.6 755.437 1256.11 752.932 1259.2 752.932C1262.28 752.932 1264.79 755.437 1264.79 758.523Z",
    fill: "url(#paint21_radial_75_3609)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M1508.77 587.333C1508.77 590.512 1506.2 593.08 1503.03 593.08C1499.85 593.08 1497.28 590.512 1497.28 587.333C1497.28 584.154 1499.84 581.585 1503.03 581.585C1506.21 581.585 1508.77 584.154 1508.77 587.333Z",
    fill: "url(#paint22_radial_75_3609)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M822.662 775.241C822.662 777.824 820.57 779.91 817.996 779.91C815.422 779.91 813.33 777.824 813.33 775.241C813.33 772.658 815.422 770.572 817.996 770.572C820.57 770.572 822.662 772.658 822.662 775.241Z",
    fill: "url(#paint23_radial_75_3609)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M588.555 756.459C588.555 760.12 585.605 763.072 581.953 763.072C578.301 763.072 575.352 760.12 575.352 756.459C575.352 752.797 578.301 749.859 581.953 749.859C585.605 749.859 588.555 752.818 588.555 756.459Z",
    fill: "url(#paint24_radial_75_3609)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M225.547 693.304C225.547 697.115 222.455 700.216 218.64 700.216C214.825 700.216 211.733 697.115 211.733 693.304C211.733 689.494 214.825 686.393 218.64 686.393C222.455 686.393 225.547 689.479 225.547 693.304Z",
    fill: "url(#paint25_radial_75_3609)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M2.17697 499.797C2.17697 502.692 -0.170195 505.034 -3.06337 505.034C-5.95655 505.034 -8.30371 502.692 -8.30371 499.797C-8.30371 496.902 -5.96364 494.546 -3.06337 494.546C-0.163104 494.546 2.17697 496.888 2.17697 499.797Z",
    fill: "url(#paint26_radial_75_3609)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M163.223 300.28C163.223 302.374 161.529 304.062 159.437 304.062C157.345 304.062 155.657 302.374 155.657 300.28C155.657 298.187 157.352 296.498 159.437 296.498C161.522 296.498 163.223 298.194 163.223 300.28Z",
    fill: "url(#paint27_radial_75_3609)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M238.835 254.419C238.835 257.811 236.077 260.564 232.68 260.564C229.284 260.564 226.532 257.811 226.532 254.419C226.532 251.027 229.284 248.26 232.68 248.26C236.077 248.26 238.835 251.013 238.835 254.419Z",
    fill: "url(#paint28_radial_75_3609)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M1616.56 260.095C1616.56 262.622 1614.51 264.687 1611.98 264.687C1609.46 264.687 1607.39 262.622 1607.39 260.095C1607.39 257.569 1609.44 255.519 1611.98 255.519C1614.52 255.519 1616.56 257.562 1616.56 260.095Z",
    fill: "url(#paint29_radial_75_3609)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M1239.11 604.222C1239.11 607.401 1236.54 609.969 1233.37 609.969C1230.19 609.969 1227.62 607.401 1227.62 604.222C1227.62 601.043 1230.2 598.467 1233.37 598.467C1236.54 598.467 1239.11 601.036 1239.11 604.222Z",
    fill: "url(#paint30_radial_75_3609)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M1110.46 689.344C1110.46 692.239 1108.1 694.595 1105.21 694.595C1102.32 694.595 1099.96 692.239 1099.96 689.344C1099.96 686.449 1102.32 684.107 1105.21 684.107C1108.1 684.107 1110.46 686.449 1110.46 689.344Z",
    fill: "url(#paint31_radial_75_3609)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M1025.57 706.169C1025.57 710.185 1022.3 713.435 1018.3 713.435C1014.29 713.435 1011.04 710.185 1011.04 706.169C1011.04 702.153 1014.28 698.896 1018.3 698.896C1022.31 698.896 1025.57 702.145 1025.57 706.169Z",
    fill: "url(#paint32_radial_75_3609)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M742.788 716.025C742.788 719.375 740.079 722.071 736.746 722.071C733.413 722.071 730.697 719.367 730.697 716.025C730.697 712.683 733.399 709.979 736.746 709.979C740.093 709.979 742.788 712.683 742.788 716.025Z",
    fill: "url(#paint33_radial_75_3609)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M718.664 717.268C718.664 719.247 717.054 720.865 715.075 720.865C713.097 720.865 711.487 719.247 711.487 717.268C711.487 715.288 713.097 713.67 715.075 713.67C717.054 713.67 718.664 715.281 718.664 717.268Z",
    fill: "url(#paint34_radial_75_3609)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M527.296 683.98C527.296 686.109 525.566 687.833 523.445 687.833C521.325 687.833 519.588 686.102 519.588 683.98C519.588 681.858 521.318 680.127 523.445 680.127C525.573 680.127 527.296 681.844 527.296 683.98Z",
    fill: "url(#paint35_radial_75_3609)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M367.014 701.876C367.014 705.19 364.341 707.858 361.037 707.858C357.732 707.858 355.052 705.19 355.052 701.876C355.052 698.563 357.732 695.895 361.037 695.895C364.341 695.895 367.014 698.577 367.014 701.876Z",
    fill: "url(#paint36_radial_75_3609)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M280.985 646.166C280.985 649.593 278.22 652.368 274.795 652.368C271.37 652.368 268.611 649.593 268.611 646.166C268.611 642.739 271.377 639.985 274.795 639.985C278.213 639.985 280.985 642.753 280.985 646.166Z",
    fill: "url(#paint37_radial_75_3609)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M166.769 596.806C166.769 600.24 163.996 603.015 160.579 603.015C157.161 603.015 154.381 600.24 154.381 596.806C154.381 593.371 157.154 590.618 160.579 590.618C164.004 590.618 166.769 593.386 166.769 596.806Z",
    fill: "url(#paint38_radial_75_3609)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M1495.4 539.01C1495.4 540.997 1493.79 542.607 1491.8 542.607C1489.82 542.607 1488.21 540.997 1488.21 539.01C1488.21 537.023 1489.82 535.412 1491.8 535.412C1493.79 535.412 1495.4 537.023 1495.4 539.01Z",
    fill: "url(#paint39_radial_75_3609)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1392.23 512.095C1392.23 515.792 1389.23 518.793 1385.55 518.793C1381.87 518.793 1378.85 515.792 1378.85 512.095C1378.85 508.398 1381.85 505.41 1385.55 505.41C1389.25 505.41 1392.23 508.405 1392.23 512.095Z",
    fill: "url(#paint40_radial_75_3609)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1211.5 545.148C1211.5 547.986 1209.2 550.299 1206.37 550.299C1203.54 550.299 1201.22 547.986 1201.22 545.148C1201.22 542.309 1203.53 540.003 1206.37 540.003C1209.21 540.003 1211.5 542.302 1211.5 545.148Z",
    fill: "url(#paint41_radial_75_3609)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M1043.92 613.262C1043.92 614.674 1042.76 615.831 1041.35 615.831C1039.94 615.831 1038.79 614.674 1038.79 613.262C1038.79 611.85 1039.93 610.693 1041.35 610.693C1042.77 610.693 1043.92 611.85 1043.92 613.262Z",
    fill: "url(#paint42_radial_75_3609)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M862.372 640.645C862.372 644.697 859.089 647.989 855.04 647.989C850.991 647.989 847.708 644.697 847.708 640.645C847.708 636.593 850.991 633.308 855.04 633.308C859.089 633.308 862.372 636.6 862.372 640.645Z",
    fill: "url(#paint43_radial_75_3609)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M704.034 666.034C704.034 669.036 701.609 671.47 698.603 671.47C695.596 671.47 693.171 669.043 693.171 666.034C693.171 663.025 695.603 660.599 698.603 660.599C701.602 660.599 704.034 663.025 704.034 666.034Z",
    fill: "url(#paint44_radial_75_3609)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M544.364 633.549C544.364 637.061 541.521 639.9 538.018 639.9C534.515 639.9 531.664 637.061 531.664 633.549C531.664 630.036 534.508 627.205 538.018 627.205C541.528 627.205 544.364 630.036 544.364 633.549Z",
    fill: "url(#paint45_radial_75_3609)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M77.8604 447.294C77.8604 450.814 75.0098 453.666 71.4997 453.666C67.9896 453.666 65.1318 450.814 65.1318 447.294C65.1318 443.774 67.9825 440.922 71.4997 440.922C75.0169 440.922 77.8604 443.774 77.8604 447.294Z",
    fill: "url(#paint46_radial_75_3609)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M124.598 368.238C124.598 371.481 121.974 374.092 118.748 374.092C115.521 374.092 112.891 371.481 112.891 368.238C112.891 364.995 115.507 362.384 118.748 362.384C121.989 362.384 124.598 364.995 124.598 368.238Z",
    fill: "url(#paint47_radial_75_3609)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M222.264 309.051C222.264 312.442 219.52 315.174 216.144 315.174C212.769 315.174 210.018 312.442 210.018 309.051C210.018 305.659 212.762 302.927 216.144 302.927C219.527 302.927 222.264 305.659 222.264 309.051Z",
    fill: "url(#paint48_radial_75_3609)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1472.59 332.894C1472.59 335.207 1470.71 337.095 1468.39 337.095C1466.07 337.095 1464.2 335.207 1464.2 332.894C1464.2 330.58 1466.07 328.679 1468.39 328.679C1470.71 328.679 1472.59 330.559 1472.59 332.894Z",
    fill: "url(#paint49_radial_75_3609)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M1444.86 496.718C1444.86 498.542 1443.38 500.025 1441.55 500.025C1439.73 500.025 1438.24 498.542 1438.24 496.718C1438.24 494.894 1439.73 493.404 1441.55 493.404C1443.38 493.404 1444.86 494.887 1444.86 496.718Z",
    fill: "url(#paint50_radial_75_3609)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M1349.75 458.761C1349.75 462.217 1346.96 465.005 1343.51 465.005C1340.07 465.005 1337.27 462.217 1337.27 458.761C1337.27 455.305 1340.07 452.517 1343.51 452.517C1346.96 452.517 1349.75 455.305 1349.75 458.761Z",
    fill: "url(#paint51_radial_75_3609)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M1123.16 500.159C1123.16 501.593 1122 502.763 1120.55 502.763C1119.11 502.763 1117.95 501.6 1117.95 500.159C1117.95 498.719 1119.11 497.548 1120.55 497.548C1122 497.548 1123.16 498.726 1123.16 500.159Z",
    fill: "url(#paint52_radial_75_3609)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M1055.12 520.929C1055.12 524.385 1052.33 527.181 1048.88 527.181C1045.42 527.181 1042.63 524.385 1042.63 520.929C1042.63 517.474 1045.42 514.678 1048.88 514.678C1052.33 514.678 1055.12 517.474 1055.12 520.929Z",
    fill: "url(#paint53_radial_75_3609)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M935.063 572.41C935.063 574.908 933.042 576.924 930.553 576.924C928.064 576.924 926.043 574.901 926.043 572.41C926.043 569.92 928.071 567.897 930.553 567.897C933.035 567.897 935.063 569.92 935.063 572.41Z",
    fill: "url(#paint54_radial_75_3609)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M527.231 573.369C527.231 575.356 525.615 576.966 523.636 576.966C521.658 576.966 520.041 575.356 520.041 573.369C520.041 571.382 521.651 569.785 523.636 569.785C525.622 569.785 527.231 571.396 527.231 573.369Z",
    fill: "url(#paint55_radial_75_3609)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M410.696 571.942C410.696 575.915 407.477 579.116 403.52 579.116C399.563 579.116 396.344 575.915 396.344 571.942C396.344 567.968 399.556 564.768 403.52 564.768C407.484 564.768 410.696 567.975 410.696 571.942Z",
    fill: "url(#paint56_radial_75_3609)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M136.344 459.675C139.135 458.512 140.455 455.305 139.293 452.512C138.131 449.719 134.926 448.398 132.135 449.561C129.344 450.724 128.023 453.931 129.186 456.724C130.348 459.517 133.553 460.838 136.344 459.675Z",
    fill: "url(#paint57_radial_75_3609)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M294.813 300.302C294.813 302.168 293.288 303.693 291.416 303.693C289.544 303.693 288.02 302.168 288.02 300.302C288.02 298.435 289.537 296.896 291.416 296.896C293.295 296.896 294.813 298.421 294.813 300.302Z",
    fill: "url(#paint58_radial_75_3609)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1405.57 152.94C1405.57 155.7 1403.32 157.928 1400.57 157.928C1397.82 157.928 1395.58 155.7 1395.58 152.94C1395.58 150.179 1397.82 147.951 1400.57 147.951C1403.32 147.951 1405.57 150.186 1405.57 152.94Z",
    fill: "url(#paint59_radial_75_3609)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1433.58 165.797C1433.58 167.316 1432.33 168.55 1430.81 168.55C1429.29 168.55 1428.06 167.316 1428.06 165.797C1428.06 164.279 1429.3 163.044 1430.81 163.044C1432.32 163.044 1433.58 164.279 1433.58 165.797Z",
    fill: "url(#paint60_radial_75_3609)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1432.95 256.867C1432.95 259.201 1431.07 261.089 1428.73 261.089C1426.4 261.089 1424.51 259.201 1424.51 256.867C1424.51 254.532 1426.4 252.645 1428.73 252.645C1431.07 252.645 1432.95 254.532 1432.95 256.867Z",
    fill: "url(#paint61_radial_75_3609)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1273.63 257.789C1273.63 260.046 1271.81 261.87 1269.56 261.87C1267.31 261.87 1265.48 260.046 1265.48 257.789C1265.48 255.533 1267.32 253.73 1269.56 253.73C1271.8 253.73 1273.63 255.554 1273.63 257.789Z",
    fill: "url(#paint62_radial_75_3609)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M1280.54 334.078C1280.54 337.207 1278 339.748 1274.87 339.748C1271.74 339.748 1269.19 337.207 1269.19 334.078C1269.19 330.949 1271.73 328.408 1274.87 328.408C1278.01 328.408 1280.54 330.949 1280.54 334.078Z",
    fill: "url(#paint63_radial_75_3609)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M1267.13 390.548C1267.13 394.358 1264.05 397.452 1260.23 397.452C1256.4 397.452 1253.33 394.366 1253.33 390.548C1253.33 386.73 1256.41 383.644 1260.23 383.644C1264.04 383.644 1267.13 386.723 1267.13 390.548Z",
    fill: "url(#paint64_radial_75_3609)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M262.449 465.027C262.449 467.184 260.705 468.937 258.549 468.937C256.393 468.937 254.642 467.184 254.642 465.027C254.642 462.87 256.393 461.117 258.549 461.117C260.705 461.117 262.449 462.87 262.449 465.027Z",
    fill: "url(#paint65_radial_75_3609)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M1040.78 128.068C1040.78 131.375 1038.1 134.057 1034.79 134.057C1031.49 134.057 1028.81 131.375 1028.81 128.068C1028.81 124.761 1031.5 122.079 1034.79 122.079C1038.08 122.079 1040.78 124.754 1040.78 128.068Z",
    fill: "url(#paint66_radial_75_3609)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M1091.05 217.194C1091.05 218.599 1089.92 219.734 1088.51 219.734C1087.11 219.734 1085.97 218.592 1085.97 217.194C1085.97 215.796 1087.1 214.646 1088.51 214.646C1089.93 214.646 1091.05 215.789 1091.05 217.194Z",
    fill: "url(#paint67_radial_75_3609)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M1033.63 368.387C1033.63 371.942 1030.77 374.802 1027.23 374.802C1023.68 374.802 1020.82 371.942 1020.82 368.387C1020.82 364.832 1023.67 361.979 1027.23 361.979C1030.78 361.979 1033.63 364.839 1033.63 368.387Z",
    fill: "url(#paint68_radial_75_3609)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M955.557 383.878C955.557 387.731 952.437 390.853 948.594 390.853C944.75 390.853 941.623 387.731 941.623 383.878C941.623 380.025 944.743 376.924 948.594 376.924C952.444 376.924 955.557 380.032 955.557 383.878Z",
    fill: "url(#paint69_radial_75_3609)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M754.878 457.619C754.878 461.153 752.013 464.012 748.489 464.012C744.965 464.012 742.093 461.153 742.093 457.619C742.093 454.085 744.958 451.226 748.489 451.226C752.02 451.226 754.878 454.085 754.878 457.619Z",
    fill: "url(#paint70_radial_75_3609)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M421.461 412.737C421.461 414.192 420.284 415.362 418.83 415.362C417.376 415.362 416.199 414.199 416.199 412.737C416.199 411.275 417.376 410.111 418.83 410.111C420.284 410.111 421.461 411.289 421.461 412.737Z",
    fill: "url(#paint71_radial_75_3609)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M286.871 323.648C286.871 325.28 285.552 326.599 283.914 326.599C282.276 326.599 280.964 325.28 280.964 323.648C280.964 322.015 282.283 320.688 283.914 320.688C285.545 320.688 286.871 322.015 286.871 323.648Z",
    fill: "url(#paint72_radial_75_3609)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M356.641 297.896C356.641 302.133 353.209 305.567 348.983 305.567C344.756 305.567 341.324 302.133 341.324 297.896C341.324 293.66 344.749 290.226 348.983 290.226C353.216 290.226 356.641 293.66 356.641 297.896Z",
    fill: "url(#paint73_radial_75_3609)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M622.884 255.242C622.884 256.647 621.742 257.783 620.331 257.783C618.92 257.783 617.785 256.647 617.785 255.242C617.785 253.837 618.927 252.681 620.331 252.681C621.735 252.681 622.884 253.823 622.884 255.242Z",
    fill: "url(#paint74_radial_75_3609)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M972.923 269.129C972.923 273.408 969.469 276.864 965.193 276.864C960.917 276.864 957.464 273.408 957.464 269.129C957.464 264.85 960.917 261.395 965.193 261.395C969.469 261.395 972.923 264.864 972.923 269.129Z",
    fill: "url(#paint75_radial_75_3609)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M1084.5 293.944C1084.5 296.818 1082.17 299.152 1079.3 299.152C1076.42 299.152 1074.09 296.818 1074.09 293.944C1074.09 291.07 1076.41 288.735 1079.3 288.735C1082.18 288.735 1084.5 291.056 1084.5 293.944Z",
    fill: "url(#paint76_radial_75_3609)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M1112.51 337.059C1112.51 338.84 1111.06 340.287 1109.29 340.287C1107.51 340.287 1106.06 338.84 1106.06 337.059C1106.06 335.278 1107.51 333.83 1109.29 333.83C1111.06 333.83 1112.51 335.278 1112.51 337.059Z",
    fill: "url(#paint77_radial_75_3609)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M965.109 320.894C965.109 323.477 963.024 325.57 960.443 325.57C957.861 325.57 955.77 323.477 955.77 320.894C955.77 318.311 957.861 316.218 960.443 316.218C963.024 316.218 965.109 318.311 965.109 320.894Z",
    fill: "url(#paint78_radial_75_3609)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M858.196 349.356C858.196 352.499 855.643 355.061 852.494 355.061C849.346 355.061 846.786 352.499 846.786 349.356C846.786 346.212 849.339 343.644 852.494 343.644C855.65 343.644 858.196 346.205 858.196 349.356Z",
    fill: "url(#paint79_radial_75_3609)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M731.612 417.144C731.612 420.146 729.179 422.565 726.194 422.565C723.209 422.565 720.776 420.146 720.776 417.144C720.776 414.142 723.202 411.723 726.194 411.723C729.186 411.723 731.612 414.149 731.612 417.144Z",
    fill: "url(#paint80_radial_75_3609)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M388.572 296.349C388.572 300.088 385.544 303.118 381.807 303.118C378.07 303.118 375.042 300.081 375.042 296.349C375.042 292.616 378.07 289.579 381.807 289.579C385.544 289.579 388.572 292.616 388.572 296.349Z",
    fill: "url(#paint81_radial_75_3609)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M632.273 281.107C632.273 284.96 629.146 288.097 625.288 288.097C621.431 288.097 618.311 284.967 618.311 281.107C618.311 277.247 621.438 274.132 625.288 274.132C629.139 274.132 632.273 277.254 632.273 281.107Z",
    fill: "url(#paint82_radial_75_3609)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M787.979 292.653C787.979 296.598 784.774 299.805 780.824 299.805C776.874 299.805 773.662 296.598 773.662 292.653C773.662 288.707 776.867 285.479 780.824 285.479C784.781 285.479 787.979 288.686 787.979 292.653Z",
    fill: "url(#paint83_radial_75_3609)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M541.988 267.596C541.988 271.84 538.549 275.274 534.315 275.274C530.082 275.274 526.636 271.84 526.636 267.596C526.636 263.353 530.075 259.904 534.315 259.904C538.556 259.904 541.988 263.353 541.988 267.596Z",
    fill: "url(#paint84_radial_75_3609)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M495.365 223.367C495.365 225.113 493.953 226.518 492.209 226.518C490.465 226.518 489.061 225.106 489.061 223.367C489.061 221.629 490.472 220.217 492.209 220.217C493.946 220.217 495.365 221.629 495.365 223.367Z",
    fill: "url(#paint85_radial_75_3609)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M539.606 267.305C539.606 269.888 537.514 271.974 534.933 271.974C532.351 271.974 530.267 269.888 530.267 267.305C530.267 264.722 532.358 262.629 534.933 262.629C537.507 262.629 539.606 264.715 539.606 267.305Z",
    fill: "url(#paint86_radial_75_3609)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M1093.41 121.455C1093.41 124.364 1091.05 126.727 1088.13 126.727C1085.22 126.727 1082.86 124.364 1082.86 121.455C1082.86 118.546 1085.22 116.183 1088.13 116.183C1091.05 116.183 1093.41 118.546 1093.41 121.455Z",
    fill: "url(#paint87_radial_75_3609)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.93 104.58C1161.93 106.234 1160.59 107.575 1158.94 107.575C1157.29 107.575 1155.95 106.234 1155.95 104.58C1155.95 102.927 1157.29 101.586 1158.94 101.586C1160.59 101.586 1161.93 102.927 1161.93 104.58Z",
    fill: "url(#paint88_radial_75_3609)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1202.85 128.728C1202.85 130.403 1201.49 131.766 1199.81 131.766C1198.13 131.766 1196.79 130.403 1196.79 128.728C1196.79 127.054 1198.14 125.691 1199.81 125.691C1201.48 125.691 1202.85 127.054 1202.85 128.728Z",
    fill: "url(#paint89_radial_75_3609)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.133 235.501) scale(2364.39 2366.01)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(514.476 235.076) scale(2361.81 2363.44)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.39 235.153) scale(2363.81 2365.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.056 234.997) scale(2364.91 2366.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.049 235.005) scale(2364.94 2366.55)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.124 235.065) scale(2364.96 2366.57)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.404 235.217) scale(2367.02 2368.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.113 235.083) scale(2365.21 2366.82)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.717 234.92) scale(2363.81 2365.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.686 234.73) scale(2365.83 2367.44)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.227 234.94) scale(2365.26 2366.88)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.844 235.04) scale(2363.39 2365)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.886 234.971) scale(2365.24 2366.84)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.448 235.039) scale(2364.03 2365.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.809 234.79) scale(2365.72 2367.34)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.056 235.572) scale(2362.92 2364.53)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.199 235.218) scale(2364.5 2366.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.992 235.069) scale(2364.19 2365.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.755 234.969) scale(2365.88 2367.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.334 235.14) scale(2366.33 2367.95)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.072 235.401) scale(2364.44 2366.06)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.005 235.494) scale(2364.31 2365.92)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.853 235.217) scale(2365.18 2366.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.063 235.129) scale(2364.6 2366.19)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.106 234.905) scale(2365.36 2366.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.22 234.961) scale(2365.33 2366.95)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.085 235.019) scale(2364.68 2366.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.113 235.097) scale(2364.67 2366.28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.162 235.047) scale(2365.14 2366.76)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.206 235.047) scale(2364.57 2366.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.002 235.013) scale(2365.09 2366.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.722 235.175) scale(2365.51 2367.12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.993 234.933) scale(2365.32 2366.93)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.155 235.273) scale(2363.78 2365.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.035 233.94) scale(2369.51 2371.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.114 235.123) scale(2364.33 2365.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.198 234.941) scale(2365.34 2366.95)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.099 235.183) scale(2364.14 2365.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.021 234.99) scale(2364.68 2366.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.292 235.183) scale(2364.28 2365.85)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.709 235.203) scale(2363.19 2364.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.446 234.862) scale(2364.03 2365.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.617 234.636) scale(2364.17 2365.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.141 234.876) scale(2365.26 2366.87)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.114 235.046) scale(2364.75 2366.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.107 235.316) scale(2363.17 2364.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.972 235.025) scale(2364.19 2365.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.156 235.068) scale(2364.91 2366.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.064 235.075) scale(2364.27 2365.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.558 234.963) scale(2363.69 2365.34)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(514.063 235.29) scale(2362.35 2363.93)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.192 235.068) scale(2364.53 2366.14)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(514.114 234.918) scale(2361.7 2363.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.014 234.976) scale(2365.24 2366.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.188 235.11) scale(2364.36 2365.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.113 235.514) scale(2361.5 2363.14)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.127 235.402) scale(2362.48 2364.09)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.204 235.008) scale(2365.28 2366.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.113 235.047) scale(2364.67 2366.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.265 235.04) scale(2367.02 2368.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(511.173 235.054) scale(2369.73 2371.33)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.201 235.054) scale(2364.53 2366.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.312 235.054) scale(2367.27 2368.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.595 235.075) scale(2366.33 2367.95)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.901 235.111) scale(2365.35 2366.97)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.042 234.97) scale(2364.78 2366.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.098 235.047) scale(2364.81 2366.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.612 235.047) scale(2362.71 2364.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.409 235.111) scale(2363.42 2365.03)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.038 235.111) scale(2365.03 2366.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.044 235.055) scale(2365.1 2366.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.17 235.282) scale(2362.52 2364.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.262 235.061) scale(2365.98 2367.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.128 234.998) scale(2365.21 2366.83)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.12 235.069) scale(2364.63 2366.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.169 235.054) scale(2364.47 2366.08)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.423 235.076) scale(2363.47 2365.08)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.1 235.04) scale(2364.81 2366.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.232 234.969) scale(2364.25 2365.86)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.164 235.012) scale(2364.54 2366.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.127 235.054) scale(2364.68 2366.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.106 235.004) scale(2365.01 2366.63)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.093 235.055) scale(2365.22 2366.84)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.05 235.048) scale(2365.29 2366.92)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.113 235.026) scale(2365.68 2367.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.113 235.047) scale(2364.38 2366.01)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.12 235.068) scale(2363.65 2365.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.751 235.019) scale(2366.17 2367.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.735 235.111) scale(2366.15 2367.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_75_3609",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.875 235.104) scale(2365.61 2367.21)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_3609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1821,
    height: 789,
    fill: "white",
    transform: "translate(-47)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHill);
export default __webpack_public_path__ + "static/media/Hill.5bec347d3cada0caea13178eb656e2ca.svg";
export { ForwardRef as ReactComponent };